export default __webpack_public_path__ + "static/CircleStepsblack-7e79cb7b9e47261d387b47c5fdb8e8cc.jpg";